<div class="vtr-ui-button">
	<div class="button-box"
		*ngIf="label">
		<button *ngIf="alreadyJoinGroup === groupNone"
			title=""
			[disabled]="isDisabled || isLoading"
			type="button"
			class="btn button {{getButtonColor(buttonColor)}} d-flex align-items-center justify-content-center"
			[id]="linkId"
			[tabindex]="tabIndex ? tabIndex : 0"
			[attr.aria-label]="ariaLabel.length > 0 ? ariaLabel:label"
			[ngClass]="{'fullWidth': isFullWidth === true,
						'halfWidth': isHalfWidth,
						'text-upper-case': upperCaseLabel === true,
						'text-capitalize': capitalizeLabel === true,
						'regular-width': isRegular,
						'btn-size-small': btnHeight,
						'btn-gradient': isGradient,
						'btn-in-red-bg': inRedBackground,
						'btn-blue-light-gradient': inBluelightBackground,
						'disable': isDisabled,
						'loading': isLoading}"
			(click)="onClickButton($event)"
			[matTooltip]="tooltip?tooltipText:''"
			matTooltipClass="vtr-system-tooltip"
		>
			<span [hidden]="!isLoading"
				class="mr-3 mt-1 mb-1 flex-shrink-0 spinner-border progress-spinner"
				role="status">
			</span>
			<span class="text"
				[innerHTML]="label"></span>
		</button>
		<button *ngIf="alreadyJoinGroup === 'unjoined'"
			title=""
			[disabled]="isDisabled || isLoading"
			type="button"
			class="btn button {{getButtonColor(buttonColor)}} d-flex align-items-center justify-content-center"
			[routerLink]="routerPath"
			routerLinkActive="active"
			[href]="href"
			[id]="linkId"
			[tabindex]="tabIndex ? tabIndex : 0"
			[attr.aria-label]="ariaLabel.length > 0 ? ariaLabel:label"
			[ngClass]="{'fullWidth': isFullWidth === true,
						'halfWidth': isHalfWidth,
						'text-upper-case': upperCaseLabel === true,
						'text-capitalize': capitalizeLabel === true,
						'regular-width': isRegular,
						'btn-size-small': btnHeight,
						'btn-gradient': isGradient,
						'btn-in-red-bg': inRedBackground,
						'btn-blue-light-gradient': inBluelightBackground,
						'disable': isDisabled,
						'loading': isLoading}"
			(click)="onClickButton($event)"
			[matTooltip]="tooltip?tooltipText:''"
			matTooltipClass="vtr-system-tooltip">
			<span [hidden]="!isLoading"
				class="mr-3 mt-1 mb-1 flex-shrink-0 spinner-border progress-spinner"
				role="status">
			</span>
			<span class="text"
				[innerHTML]="label"></span>
		</button>
		<button *ngIf="alreadyJoinGroup === 'joined'"
			title="{{tooltip?label:''}}"
			type="button"
			class="button disable"
			[disabled]="false"
			[id]="linkId"
			[tabindex]="tabIndex ? tabIndex : 0"
			[attr.aria-label]="ariaLabel.length > 0 ? ariaLabel:label"
			[routerLink]="routerPath"
			routerLinkActive="active"
			[ngClass]="{'fullWidth': isFullWidth === true ,'text-upper-case': upperCaseLabel}"
			(click)="onClickButton($event)"
			[matTooltip]="tooltip?tooltipText:''"
			matTooltipClass="vtr-system-tooltip">
				{{label}}
			</button>
	</div>
</div>
